<div #mainDiv_ll_loanmgmt_bbc_display>
  <div *ngIf="bundle.BBCLOGONAME != ''"
       [style.top.px]="5"
       [style.left.px]="10"
       style="position: absolute;">
    <img [style.max-width.px]="150"
         [style.max-height.px]="35"
         style="width: auto; height: auto;"
         [src]="bundle.BBCLOGONAME" alt="" onerror="this.style.display='none'">
  </div>

  <div class="txtNorm12"
       [style.top.px]="50"
       [style.left.px]="bundle.panelX"
       [style.width.px]="bundle.panelW"
       [style.overflowY]="'auto'"
       style="position: absolute;">
    <div>{{ bundle.COLLATCONFIGMSG }}</div>
  </div>

  <div [style.top.px]="bundle.panelY"
       [style.left.px]="bundle.panelX"
       style="position: absolute;">
    <jqxPanel [autoUpdate]="true"
              [width]="bundle.panelW"
              [height]="bundle.panelH"
              style="background-color: transparent; border: none; border-bottom: 2px solid rgb(160, 158, 158);">
      <div class="group-label-container">
        <div *ngFor="let group of bundle.groupNames">
          <div class="group_label">
            {{ group }}
          </div>
          <div class="loan-record-rows">
            <ng-container *ngFor="let item of bundle.records | visitCategory:{GROUPNAME: group}">
              <div class="loan-record-row">
                <!-- Label + tooltip -->
                <div class="element-label-container">
                  <div class="tooltip-container">
                    <img class="info-btn"
                         src="assets/infoBtn.png"
                         alt="Info"
                         [attr.data-record-id]="item.LOANELEMENTID"
                         (mouseover)="showTooltip($event, item.LOANELEMENTID)"
                         (mouseout)="hideTooltip(item.LOANELEMENTID)">
                    <div *ngIf="tooltipVisibility[item.LOANELEMENTID]"
                         class="tooltip"
                         [style.left.px]="tooltipPosition.x"
                         [style.top.px]="tooltipPosition.y">
                      {{ item.ELEMENTDESCRIPTION || 'No description available' }}
                    </div>
                  </div>
                  <span class="element-label-text">
                    {{ item.ELEMENTLABEL }}
                  </span>
                </div>

                <!-- Value column -->
                <div class="element-value">
                  <!-- Editable date -->
                  <input *ngIf="!bundle.valueLock && item.ELEMENTCANEDITYESNO === 'Yes' && item.ELEMENTVALUETYPE === 'date' && item.LOANELEMENTID != 119"
                         type="date"
                         class="editable-input date-input"
                         [value]="item.ELEMENTVALUE | date:'yyyy-MM-dd'"
                         (change)="onValueChange(item, $event.target.value)"
                         [min]="this.bundle.minDateString"
                         [max]="this.bundle.maxDateString"
                         [disabled]="bundle.valueLock">

                  <!-- Editable dropdown for MONTHENDDATE_NUM-->
                  <select *ngIf="!bundle.valueLock && item.ELEMENTCANEDITYESNO === 'Yes' && item.LOANELEMENTID === 119"
                          class="editable-input dropdown-input"
                          (change)="onValueChange(item, $event.target.value)">
                    <option value="">Select...</option>
                    <ng-container *ngFor="let opt of getMONTHENDDATE_NUMOptions(item)">
                      <option [ngValue]="opt.value"
                              [selected]="isSelected(opt.value, item.ELEMENTVALUE)">
                        {{ opt.label }}
                      </option>
                    </ng-container>
                  </select>

                  <!-- Editable number/text -->
                  <input *ngIf="!bundle.valueLock && item.ELEMENTCANEDITYESNO === 'Yes' && item.ELEMENTVALUETYPE !== 'dropdown' && item.ELEMENTVALUETYPE !== 'date'"
                         type="text"
                         class="editable-input text-input"
                         [value]="item.formattedValue"
                         (input)="onValueChange(item, $event.target.value)"
                         [placeholder]="getInputPlaceholder(item.ELEMENTVALUETYPE)"
                         [disabled]="bundle.valueLock" />

                  <!-- Read-only display: uses pre-formatted value -->
                  <ng-container *ngIf="bundle.valueLock || item.ELEMENTCANEDITYESNO !== 'Yes'">
                    {{ item.formattedValue }}
                  </ng-container>
                </div>

                <!-- Note column -->
                <div class="element-note" [class.editable-note]="!bundle.valueLock && item.ELEMENTCANEDITYESNO === 'Yes'">
                  <input *ngIf="!bundle.valueLock && item.ELEMENTCANEDITYESNO === 'Yes'"
                         type="text"
                         class="editable-input note-input"
                         [value]="item.ELEMENTNOTE || ''"
                         (input)="onNoteChange(item, $event.target.value)"
                         [placeholder]="'Enter note...'"
                         [disabled]="bundle.valueLock">

                  <ng-container *ngIf="bundle.valueLock && item.ELEMENTCANEDITYESNO === 'Yes'">
                    {{ item.ELEMENTNOTE || '' }}
                  </ng-container>

                  <ng-container *ngIf="item.ELEMENTCANEDITYESNO !== 'Yes'">
                    <span [style.color]="'red'">
                      {{ item.ELEMENTNOTE || '' }}
                    </span>
                  </ng-container>
                </div>
              </div>
            </ng-container>

            <div *ngIf="!bundle.records?.length" class="no-records">
              No records found for this category.
            </div>
          </div>
        </div>
      </div>
    </jqxPanel>
  </div>

  <!-- Signature Popup -->
  <div class="signature-popup" *ngIf="bundle.showSignaturePopup"
       [style.top.px]="40"
       [style.left.px]="(bundle.panelW - 600) / 2"
       [style.width.px]="600">
    <div class="close-btn" (click)="closeSignaturePopup()">
      <img src="assets/icon_closeForm.png" alt="Close">
    </div>
    <div class="signature-container">
      <div *ngIf="bundle.sigType === 'client'">
        <p class="signature-text">{{ bundle.BBCLANGUAGE }}</p>
      </div>
      <div *ngIf="bundle.sigType === 'approve'">
        <p class="signature-text">{{ bundle.BBCAPPROVALLANGUAGE }}</p>
      </div>
      <div *ngIf="bundle.sigType === 'delete'">
        <p class="signature-text">Click the 'Confirm Delete' word button below to confirm that you want to delete this BBC</p>
      </div>

      <div *ngIf="bundle.sigType != 'delete'">
        <input type="text" class="signature-input" placeholder="Sign here" #signatureInput
               (input)="onSignatureInput($event)">
        <p class="signature-name">{{ bundle.CONTACTFIRST }} {{ bundle.CONTACTLAST }}</p>
        <input type="text" class="signature-title" placeholder="Title" #titleInput
               (input)="onTitleInput($event)">
      </div>

      <div class="notice-submit">
        <p class="signature-notice" *ngIf="!bundle.sigAndTitle && bundle.sigType != 'delete'">
          Typed signature must match name below the line and Title is required
        </p>

        <div class="wordBtn14" *ngIf="bundle.sigType === 'client' && bundle.sigAndTitle" (click)="signBBC()">
          {{bundle.signLabel}} 
        </div>

        <div *ngIf="bundle.sigType === 'client' && bundle.sigAndTitle">
          <p class="signature-text">BBC will be emailed to: {{bundle.emailSignedTo}}</p>
        </div>

        <div class="wordBtn14" *ngIf="bundle.sigType === 'approve' && bundle.sigAndTitle" (click)="approveBBCValues()">
          {{bundle.approveLabel}}
        </div>

        <div *ngIf="bundle.sigType === 'approve' && bundle.sigAndTitle">
          <p class="signature-text">BBC will be emailed to: {{bundle.emailApprovedTo}}</p>
        </div>

        <div class="wordBtn14" *ngIf="bundle.sigType === 'delete'" (click)="deleteBBC()">
          Confirm Delete
        </div>
      </div>
    </div>
  </div>

  <div class="wordBtn"
       *ngIf="bundle.showDelete"
       (click)="openSignaturePopup('delete')"
       [style.top.px]="bundle.panelY + bundle.panelH + 10"
       [style.left.px]="bundle.panelX + 20"
       [style.width.px]="200"
       style="position: absolute; text-align: center;">
    <span>Delete BBC</span>
  </div>

  <div *ngIf="bundle.showClientSig"
       class="wordBtn"
       (click)="openSignaturePopup('client')"
       [style.top.px]="bundle.panelY + bundle.panelH + 10"
       [style.left.px]="bundle.panelX + 320"
       [style.width.px]="200"
       style="position: absolute; text-align: center;">
    <span>{{bundle.signLabel}}</span>
  </div>

  <!-- Action Buttons -->
  <div class="wordBtn"
       *ngIf="bundle.showApprovalSig"
       (click)="openSignaturePopup('approve')"
       [style.top.px]="bundle.panelY + bundle.panelH + 10"
       [style.left.px]="bundle.panelX + 200"
       [style.width.px]="350"
       style="position: absolute; text-align: center;">
    <span>{{bundle.approveLabel}}</span>
  </div>




</div>
